import { useState } from "react";
import { updateAppointment } from "@/lib/apiClient";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SlotPicker } from "@/components/SlotPicker";

export function RescheduleButton({ appt, onDone }) {
  const [open, setOpen] = useState(false);
  const [slot, setSlot] = useState("");
  const save = async () => {
    if (!slot) return toast.error("Kies een nieuw tijdslot");
    try { await updateAppointment(appt.id, { start: slot }); toast.success("Afspraak verplaatst — klant en adviseur krijgen een e-mail"); setOpen(false); setSlot(""); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Verplaatsen mislukt"); }
  };
  return (
    <>
      <button data-testid={`reschedule-${appt.id}`} onClick={() => setOpen(true)} title="Verplaatsen" className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1.5 rounded-lg border border-[#E2E7EC] bg-white text-[#001C51] hover:bg-[#EDF1F5]">
        <CalendarClock className="h-3.5 w-3.5" /> Verplaatsen
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="reschedule-dialog">
          <DialogHeader><DialogTitle>Afspraak verplaatsen</DialogTitle></DialogHeader>
          <p className="text-sm text-[#5B6675]">{appt.lead_name} · adviseur {appt.user_name}</p>
          <SlotPicker advisorId={appt.user_id} value={slot} onPick={setSlot} excludeId={appt.id} />
          <button data-testid="reschedule-save" onClick={save} className="w-full py-2.5 rounded-xl bg-[#001C51] text-white text-sm font-medium hover:bg-[#0A337A]">Verplaatsen</button>
        </DialogContent>
      </Dialog>
    </>
  );
}
